// @ts-nocheck
import { Redirect } from "react-router-dom"

const CustomerLogout = () => {
    return <Redirect to="/auth/logout" />
}

export default CustomerLogout